var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export default {
    type: 'dom',
    init: function (GG) {
        if (typeof GG.$ !== 'undefined') {
            GG.Catalog = this.plugin.bind(GG);
            GG.log('Catalog plugin loaded.');
        }
        else {
            GG.log('Catalog plugin needs jQuery.');
        }
    },
    plugin: function (params) {
        var $ = this.$;
        var app = this;
        app.historyBackupUrl = function () {
            window._history_backup_url =
                location.protocol + '//' + location.host + location.pathname + window.location.search;
            window._history_backup_title = document.title;
        };
        app.historyRestoreUrl = function () {
            var title = window._history_backup_title ? window._history_backup_title : document.title;
            var url = window._history_backup_url
                ? window._history_backup_url
                : location.protocol + '//' + location.host + location.pathname + window.location.search;
            if (typeof window.history.pushState !== 'undefined') {
                if (document.defaultView.location.origin &&
                    document.defaultView.location.origin !== 'null' &&
                    !/file:\/\//.test(document.defaultView.location.origin)) {
                    window.history.pushState({
                        initialState: true
                    }, title, url);
                    document.title = title;
                }
            }
        };
        var _params = __assign({
            popup: null,
            container_selector: null,
            title_selector: ''
        }, params);
        var scope = {
            current_page: 0,
            total_pages: 0,
            items: [],
            current_url: '',
            history_index: 0
        };
        var _preload, preloaded;
        if (_params.loading && !(_params.loading instanceof jQuery)) {
            throw 'Loading should be a jQuery-object!';
        }
        if (_params.popup && !(_params.popup instanceof jQuery)) {
            throw 'Popup should be a jQuery-object';
        }
        if (_params.popup_prev_selector) {
            _params.popup_prev_selector.toString();
        }
        if (_params.popup_next_selector) {
            _params.popup_next_selector.toString();
        }
        if (!_params.container_selector) {
            throw 'Gimme container selector!';
        }
        if (!_params.title_selector) {
            throw 'Gimme title selector!';
        }
        else {
            _params.title_selector = _params.title_selector.toString();
        }
        if (_params.catalog_list_loading) {
            _params.catalog_list_loading.toString();
        }
        if (_params.catalog_list_selector) {
            _params.catalog_list_selector.toString();
        }
        if (_params.catalog_entry_selector) {
            _params.catalog_entry_selector.toString();
        }
        if (_params.catalog_entry_link_selector) {
            _params.catalog_entry_link_selector.toString();
        }
        if (_params.item_gethref && typeof _params.item_gethref !== 'function') {
            throw 'Gimme catalog list item href Function!';
        }
        if (!_params.current_page || (_params.current_page && !Number.isInteger(_params.current_page))) {
            throw 'current_page should be an integer!';
        }
        if (!_params.total_pages || (_params.total_pages && !Number.isInteger(_params.total_pages))) {
            throw 'total_pages should be an integer!';
        }
        if (typeof _params.filters !== 'function') {
            _params.filters = function () {
                return {};
            };
        }
        var _methods = {
            getCurrentUrl: function () {
                return scope.current_url;
            },
            setCurrentPage: function (page) {
                if (typeof page === 'undefined' || !Number.isInteger(page) || page <= 0) {
                    throw 'Page should be an integer!';
                }
                scope.current_page = page;
            },
            getCurrentPage: function () {
                return scope.current_page;
            },
            setTotalPages: function (pages) {
                if (typeof pages === 'undefined' || !Number.isInteger(pages) || pages <= 0) {
                    throw 'Pages should be an integer!';
                }
                scope.total_pages = pages;
            },
            getTotalPages: function () {
                return scope.total_pages;
            },
            parseItems: function (params) {
                if (typeof params === 'undefined') {
                    throw 'Gimme params!';
                }
                else {
                    if (!params.parent || !params.selector || !params.link) {
                        throw 'Gimme selectors!';
                    }
                }
                scope.items = [];
                $(params.selector, $(params.parent)).each(function () {
                    var $entry = $(this);
                    scope.items.push($entry.find(params.link).attr('href'));
                });
            },
            loadItems: function (params) {
                if (!_params.catalog_list_selector) {
                    return false;
                }
                params = __assign({
                    send_params: [],
                    async: true,
                    url: '/catalog/ajax/list_items',
                    page: _methods.getCurrentPage()
                }, params);
                if (!params.append) {
                    params.append = params.page == 1 ? false : true;
                }
                if (scope.loadingItems) {
                    return false;
                }
                $.ajax({
                    url: params.url,
                    async: params.async,
                    beforeSend: function () {
                        if (typeof params.beforeSend === 'function')
                            params.beforeSend();
                        scope.loadingItems = true;
                        if (params.page == 1 && _params.catalog_list_loading) {
                            $(_params.catalog_list_loading).fadeIn();
                        }
                    },
                    data: __assign({}, _params.filters(), {
                        page: params.page
                    })
                })
                    .done(function (data) {
                    if (data) {
                        if (data.items_count != 0) {
                            if (params.append) {
                                $(data.html).appendTo($(_params.catalog_list_selector));
                            }
                            else {
                                $(_params.catalog_list_selector).html(data.html);
                            }
                        }
                        else {
                            if (!params.append) {
                                $(_params.catalog_list_selector).html(_params.no_items || '');
                            }
                        }
                        _methods.setCurrentPage(data.current_page);
                        _methods.setTotalPages(data.total_pages);
                        _methods.parseItems({
                            parent: _params.catalog_list_selector,
                            selector: _params.catalog_entry_selector,
                            link: _params.catalog_entry_link_selector
                        });
                    }
                    if (typeof _params.load_items_callback === 'function')
                        _params.load_items_callback(data, params);
                    if (typeof params.success === 'function')
                        params.success(data, params);
                })
                    .always(function () {
                    if (typeof params.always === 'function')
                        params.always.apply(this, arguments);
                    setTimeout(function () {
                        scope.loadingItems = false;
                        if (_params.catalog_list_loading)
                            $(_params.catalog_list_loading).fadeOut();
                    }, 500);
                });
            },
            getItems: function () {
                return scope.items;
            },
            getItemIndexByUrl: function (url) {
                if (typeof url === 'undefined') {
                    throw 'Gimme url!';
                }
                scope.items.indexOf(url);
            },
            getItem: function (params) {
                if (_params.popup) {
                    scope.processingGetItem = true;
                    if (typeof params === 'undefined') {
                        throw 'Gimme params!';
                    }
                    else {
                        if (!params.url) {
                            throw 'Gimme url!';
                        }
                        else {
                            params.url = params.url.toString();
                        }
                    }
                    if (!params.preload) {
                        if (!_params.popup.is('.opened')) {
                            _params.popup.find(_params.container_selector).html('');
                            app.historyBackupUrl();
                            app.togglePopup(_params.popup.attr('id'));
                        }
                    }
                    if (_preload && (preloaded = _preload.getPreloadedItem(params.url))) {
                        if (!params.preload) {
                            _methods.getItemOnSuccess(preloaded.html, params);
                        }
                        scope.processingGetItem = false;
                        return false;
                    }
                    if (!scope.loadItemPending || scope.loadItemPending != params.url) {
                        if (_params.loading && !params.preload)
                            _params.loading.show();
                        $.ajax({
                            method: 'GET',
                            url: params.url,
                            data: {
                                ajax: 1
                            },
                            beforeSend: function () {
                                scope.loadItemPending = params.url;
                            },
                            success: function (html) {
                                if (params.preload) {
                                    _preload.addPreloadedItem(params.url, html);
                                    scope.loadItemPending = null;
                                    scope.processingGetItem = false;
                                    app.callback('preloadItemSuccess', html);
                                    app.callback('preloadItemSuccess', null);
                                }
                                else {
                                    scope.loadItemPending = null;
                                    scope.processingGetItem = false;
                                    _methods.getItemOnSuccess(html, params);
                                }
                            }
                        });
                    }
                    else {
                        if (_params.loading && (!_methods.getSwiping || !_methods.getSwiping()))
                            _params.loading.show();
                        if (!params.preload) {
                            app.callback('preloadItemSuccess', function (html) {
                                _methods.getItemOnSuccess(html, {
                                    url: params.url,
                                    history_increment: params.history_increment
                                });
                            });
                        }
                    }
                }
                else {
                    if (params.url)
                        window.location.href = params.url;
                }
            },
            getItemOnSuccess: function (html, params) {
                if (_params.item_preload)
                    _preload.addPreloadedItem(params.url, html);
                _params.popup
                    .find('.popup-container:not(.popup-container_pseudo)')
                    .find(_params.container_selector)
                    .html(html);
                var item_title_container = _params.popup
                    .find('.popup-container:not(.popup-container_pseudo)')
                    .find(_params.container_selector)
                    .find(_params.title_selector), item_title = item_title_container.attr('data-seotitle') || item_title_container.text();
                if (typeof params.history_increment === 'undefined' || params.history_increment !== false) {
                    scope.history_index++;
                    window.history.pushState({
                        url: params.url,
                        historyIndex: scope.history_index
                    }, item_title, location.protocol + '//' + location.host + params.url);
                }
                document.title = item_title;
                if (_params.popup_prev_selector && _params.popup_next_selector) {
                    if (scope.items.indexOf(params.url) <= 0) {
                        _params.popup.find(_params.popup_prev_selector).hide();
                    }
                    else {
                        _params.popup
                            .find(_params.popup_prev_selector)
                            .show()
                            .attr('href', scope.items[scope.items.indexOf(params.url) - 1]);
                    }
                    if (scope.current_page == scope.total_pages && scope.items.indexOf(params.url) == scope.items.length - 1) {
                        _params.popup.find(_params.popup_next_selector).hide();
                    }
                    else {
                        _params.popup
                            .find(_params.popup_next_selector)
                            .show()
                            .attr('href', scope.items[scope.items.indexOf(params.url) + 1]);
                        if (_params.item_preload && scope.items.indexOf(params.url) < scope.items.length - 1)
                            _preload.preloadFunction(null, _methods.getItem, scope.items[scope.items.indexOf(params.url) + 1]);
                    }
                    if (scope.items.length == 1) {
                        _params.popup.find(_params.popup_prev_selector).hide();
                        _params.popup.find(_params.popup_next_selector).hide();
                    }
                }
                if (_params.get_item_callback && typeof _params.get_item_callback === 'function') {
                    if (_params.popup && _params.popup_swiping && $.fn.swipe && (_params.swipe_debug || app.isMobile)) {
                        setTimeout(function () {
                            $('.popup-container:not(.popup-container_pseudo)').css('height', '');
                        }, 100);
                    }
                    _params.get_item_callback(html);
                }
                scope.current_url = params.url;
                setTimeout(function () {
                    if (_params.loading)
                        _params.loading.stop(true, true).fadeOut();
                    scope.processingGetItem = false;
                }, 100);
            }
        };
        if (_params.popup && _params.item_preload) {
            var _preload_1 = {
                preloadedItems: [],
                getPreloadedItem: function (url) {
                    for (var i = 0, k = _preload_1.preloadedItems.length; i < k; i++) {
                        var item = _preload_1.preloadedItems[i];
                        if (item.url == url) {
                            return item;
                        }
                    }
                    return null;
                },
                addPreloadedItem: function (url, data) {
                    if (!_preload_1.getPreloadedItem(url)) {
                        _preload_1.preloadedItems.push({
                            url: url,
                            html: data
                        });
                    }
                    if (_preload_1.preloadedItems.length > 10) {
                        _preload_1.preloadedItems.shift();
                    }
                },
                preloadFunction: function (self, func, url, timeout) {
                    var data, timestamp, diff;
                    if (self) {
                        data = $(self).data();
                        timestamp = data.mouseover_timestamp;
                        diff = new Date() - timestamp;
                    }
                    if (!self || (timestamp && diff >= timeout)) {
                        func({
                            url: url,
                            preload: true,
                            history_increment: false
                        });
                    }
                },
                preloadMouseEnter: function (params) {
                    params.timeout = Number.isInteger(params.timeout) ? params.timeout : 400;
                    var self = this, url = params.gethref.apply(this);
                    $(this).data('mouseover_timestamp', +new Date());
                    if (!_preload_1.getPreloadedItem[url]) {
                        setTimeout(function () {
                            _preload_1.preloadFunction(self, params.func, url, params.timeout);
                        }, params.timeout);
                    }
                },
                preloadMouseLeave: function () {
                    $(this).data('mouseover_timestamp', 0);
                },
                setPreloadListener: function (params) {
                    params.gethref =
                        params.gethref ||
                            function () {
                                return $(this).attr('href') || $(this).attr('data-url') || $(this).data('url');
                            };
                    $(params.parent || 'body').on('mouseenter', params.selector, function () {
                        _preload_1.preloadMouseEnter.call(this, params);
                    });
                    $(params.parent || 'body').on('mouseleave', params.selector, _preload_1.preloadMouseLeave);
                }
            };
            if (_params.catalog_list_selector && _params.catalog_entry_selector) {
                _preload_1.setPreloadListener({
                    parent: _params.catalog_list_selector,
                    selector: _params.catalog_entry_selector,
                    func: _methods.getItem,
                    gethref: _params.item_gethref
                });
            }
        }
        if (_params.popup && _params.popup_swiping && $.fn.swipe && (_params.swipe_debug || app.isMobile)) {
            $('body').addClass('is_swiping');
            _methods.setSwiping = function (flag) {
                scope.swiping = !!flag;
            };
            _methods.getSwiping = function () {
                return scope.swiping;
            };
            $('.swipeme a').click(function () {
                $('.swipeme').hide();
                return false;
            });
            var $popupContainerReal_1 = $('.popup-container:not(.popup-container_pseudo)'), $prev_1, $next_1;
            _params.popup.find('.popup-overlay').swipe({
                excludedElements: 'button, input, select, textarea, .noSwipe',
                swipeStatus: function (event, phase, direction, distance, duration, fingers, fingerData) {
                    if (phase == $.fn.swipe.phases.PHASE_START) {
                        scope.initial_direction = null;
                        var url = _methods.getCurrentUrl(), index = scope.items.indexOf(url);
                        _methods.setSwiping(true);
                        scope.swipeStart = [
                            event.pageX || event['touches'][0].pageX || event['changedTouches'][0].pageX,
                            event.pageY || event['touches'][0].pageY || event['changedTouches'][0].pageY
                        ];
                        $prev_1 = index >= 1 ? scope.items[index - 1] : null;
                        $next_1 = index < scope.items.length - 1 ? scope.items[index + 1] : null;
                        $('.popup-container_pseudo')
                            .css('transition-duration', '0s')
                            .css('opacity', 0)
                            .css('transform', 'scale(0)')
                            .css('height', $('.popup-container:not(.popup-container_pseudo)')[0].clientHeight);
                        $popupContainerReal_1.css('transition-duration', '0s');
                    }
                    if (phase == $.fn.swipe.phases.PHASE_MOVE) {
                        scope.swipeMove = [
                            event.pageX || (event['touches'] ? event['touches'][0].pageX : null) || event['changedTouches'][0].pageX,
                            event.pageY || event['touches'][0].pageY || event['changedTouches'][0].pageY
                        ];
                        distance = scope.swipeMove[0] - scope.swipeStart[0];
                        var value = distance;
                        if (!scope.initial_direction && direction && Math.abs(distance) > 20) {
                            scope.initial_direction = direction;
                        }
                        if ((scope.initial_direction == 'left' && value < 0) || (scope.initial_direction == 'right' && value > 0)) {
                            var canShowNextItem = (scope.initial_direction == 'left' && $next_1) || (scope.initial_direction == 'right' && $prev_1);
                            $('.popup-overlay').swipe('option', 'allowPageScroll', $.fn.swipe.pageScroll.NONE);
                            $popupContainerReal_1.css('transform', 'translate3d(' + value / (canShowNextItem ? 1 : 10) + 'px,0px,0px)');
                            var opacity = Math.abs(distance) / 1000;
                            var scale = Math.abs(distance) / 1000 > 1 ? 1 : Math.abs(distance) / 1000;
                            $('.popup-container_pseudo')
                                .css('opacity', opacity)
                                .css('transform', 'scale(' + (canShowNextItem ? scale : '0') + ')');
                        }
                        else {
                            $popupContainerReal_1.css('transform', 'translate3d(0px,0px,0px)');
                        }
                    }
                    if (phase == $.fn.swipe.phases.PHASE_CANCEL) {
                        var s_1 = $('.popup-container_pseudo')[0].style;
                        s_1.opacity = 1;
                        (function fade() {
                            (s_1.opacity -= 0.001) < 0 ? (s_1.opacity = 0) : setTimeout(fade, 12);
                        })();
                        $('.popup-container_pseudo')
                            .css('transition-duration', (duration > 500 ? 500 : duration) / 1000 + 's')
                            .css('transform', 'scale(0)');
                        $popupContainerReal_1
                            .css('transition-duration', (duration > 500 ? 500 : duration) / 1000 + 's')
                            .css('transform', 'translate3d(0px,0px,0px)');
                        scope.initial_direction = null;
                        $('.popup-overlay').swipe('option', 'allowPageScroll', $.fn.swipe.pageScroll.AUTO);
                        _methods.setSwiping(false);
                    }
                    if (phase == $.fn.swipe.phases.PHASE_END) {
                        distance = scope.swipeMove[0] - scope.swipeStart[0];
                        var value_1 = distance;
                        if (scope.initial_direction == 'left' || scope.initial_direction == 'right') {
                            if ((scope.initial_direction == 'left' && value_1 < 0) ||
                                (scope.initial_direction == 'right' && value_1 > 0)) {
                                var canShowNextItem = (scope.initial_direction == 'left' && $next_1) || (scope.initial_direction == 'right' && $prev_1);
                                if (canShowNextItem &&
                                    (Math.abs(distance) > (app.isMobile ? 200 : 400) || (Math.abs(distance) > 200 && duration < 200))) {
                                    var s_2 = $('.popup-container_pseudo')[0].style;
                                    s_2.opacity = 1;
                                    (function fade() {
                                        (s_2.opacity += 0.001) < 0 ? (s_2.opacity = 1) : setTimeout(fade, 12);
                                    })();
                                    $('.popup-container_pseudo')
                                        .css('transition-duration', (duration > 500 ? 500 : duration) / 1000 + 's')
                                        .css('transform', 'scale(1)');
                                    $popupContainerReal_1
                                        .css('transition-duration', (duration > 500 ? 500 : duration) / 1000 + 's')
                                        .css('transform', 'translate3d(' + value_1 * 3 + 'px,0px,0px)');
                                    if (!_params.item_preload ||
                                        (value_1 > 0 && $prev_1 && !_preload.getPreloadedItem($prev_1)) ||
                                        (value_1 < 0 && $next_1 && !_preload.getPreloadedItem($next_1))) {
                                        $popupContainerReal_1.find('.loading').show();
                                    }
                                    $popupContainerReal_1.css('height', $popupContainerReal_1[0].clientHeight);
                                    setTimeout(function () {
                                        $('.popup-container_pseudo')
                                            .css('transition-duration', '0s')
                                            .css('opacity', 0)
                                            .css('transform', 'scale(0)');
                                        $popupContainerReal_1
                                            .css('transition-duration', '0s')
                                            .css('transform', 'translate3d(0px,0px,0px)')
                                            .find(_params.container_selector)
                                            .html('');
                                        if (value_1 > 0 && $prev_1)
                                            _methods.getItem({
                                                url: $prev_1
                                            });
                                        if (value_1 < 0 && $next_1)
                                            _methods.getItem({
                                                url: $next_1
                                            });
                                    }, duration > 500 ? 500 : duration);
                                }
                                else {
                                    var s_3 = $('.popup-container_pseudo')[0].style;
                                    s_3.opacity = 1;
                                    (function fade() {
                                        (s_3.opacity -= 0.001) < 0 ? (s_3.opacity = 0) : setTimeout(fade, 12);
                                    })();
                                    $('.popup-container_pseudo')
                                        .css('transition-duration', (duration > 500 ? 500 : duration) / 1000 + 's')
                                        .css('transform', 'scale(0)');
                                    $popupContainerReal_1
                                        .css('transition-duration', (duration > 500 ? 500 : duration) / 1000 + 's')
                                        .css('transform', 'translate3d(0px,0px,0px)');
                                }
                            }
                            else {
                                var s_4 = $('.popup-container_pseudo')[0].style;
                                s_4.opacity = 1;
                                (function fade() {
                                    (s_4.opacity -= 0.001) < 0 ? (s_4.opacity = 0) : setTimeout(fade, 12);
                                })();
                                $('.popup-container_pseudo')
                                    .css('transition-duration', (duration > 500 ? 500 : duration) / 1000 + 's')
                                    .css('transform', 'scale(0)');
                                $popupContainerReal_1
                                    .css('transition-duration', (duration > 500 ? 500 : duration) / 1000 + 's')
                                    .css('transform', 'translate3d(0px,0px,0px)');
                            }
                        }
                        $('.popup-overlay').swipe('option', 'allowPageScroll', $.fn.swipe.pageScroll.AUTO);
                        _methods.setSwiping(false);
                        scope.initial_direction = null;
                    }
                },
                allowPageScroll: $.fn.swipe.pageScroll.AUTO
            });
        }
        else {
            $('.swipeme').hide();
        }
        if (_params.popup &&
            _params.catalog_list_selector &&
            _params.catalog_entry_selector &&
            _params.catalog_entry_link_selector) {
            $('body').on('click', _params.catalog_list_selector +
                ' ' +
                _params.catalog_entry_selector +
                ' ' +
                _params.catalog_entry_link_selector, function (e) {
                e.preventDefault();
                app.catalog.getItem({
                    url: $(this).attr('href')
                });
            });
        }
        if (_params.catalog_list_selector && $(_params.catalog_list_selector).length) {
            _methods.parseItems({
                parent: _params.catalog_list_selector,
                selector: _params.catalog_entry_selector,
                link: _params.catalog_entry_link_selector
            });
            if (_params.infinite_scroll) {
                scope.currentscroll = window.pageYOffset || document.documentElement.scrollTop;
                scope.inifiniteScroll = function () {
                    var contentHeight = $(_params.catalog_list_selector)[0].offsetHeight;
                    var yOffset = window.pageYOffset;
                    var y = yOffset + window.innerHeight;
                    if (y >= parseInt(contentHeight) - 200) {
                        if (app.catalog.getCurrentPage() < app.catalog.getTotalPages()) {
                            app.catalog.loadItems({
                                success: typeof _params.infinite_scroll_callback === 'function'
                                    ? _params.infinite_scroll_callback
                                    : function () { },
                                append: true,
                                page: app.catalog.getCurrentPage() + 1,
                                always: scope.inifiniteScroll
                            });
                        }
                    }
                };
                scope.scroll_direction = function () {
                    var after = window.pageYOffset || document.documentElement.scrollTop;
                    if (after < scope.currentscroll) {
                        scope.currentscroll = after;
                        return 'up';
                    }
                    else {
                        scope.currentscroll = after;
                        return 'down';
                    }
                };
                window.addEventListener('scroll', function () {
                    if (scope.scroll_direction() === 'up')
                        return false;
                    scope.inifiniteScroll();
                });
            }
        }
        _methods.setCurrentPage(_params.current_page);
        _methods.setTotalPages(_params.total_pages);
        if (_params.popup) {
            if (_params.loading) {
                _params.popup.find('.loading, .loading_pseudo').on('touchstart', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                });
            }
            if (_params.popup_prev_selector && _params.popup_next_selector) {
                $(document).keyup(function (e) {
                    if (e.keyCode === 37) {
                        $(_params.popup)
                            .find(_params.popup_prev_selector + ':visible')
                            .click();
                    }
                    else if (e.keyCode === 39) {
                        $(_params.popup)
                            .find(_params.popup_next_selector + ':visible')
                            .click();
                    }
                });
                if (_params.preload) {
                }
                _params.popup.find(_params.popup_prev_selector).on('click', function (e) {
                    if (scope.processingGetItem)
                        return false;
                    if (_params.loading && _params.loading.is(':visible'))
                        return false;
                    var current_index = scope.items.indexOf(scope.current_url);
                    if (current_index > 0) {
                        _methods.getItem({
                            url: scope.items[current_index - 1]
                        });
                    }
                    e.preventDefault();
                });
                _params.popup.find(_params.popup_next_selector).on('click', function (e) {
                    if (scope.processingGetItem)
                        return false;
                    if (_params.loading && _params.loading.is(':visible'))
                        return false;
                    var current_index = scope.items.indexOf(scope.current_url);
                    if (current_index < scope.items.length - 1) {
                        _methods.getItem({
                            url: scope.items[current_index + 1]
                        });
                        if (current_index == scope.items.length - 2 && scope.current_page < scope.total_pages) {
                            _methods.loadItems({
                                page: scope.current_page + 1,
                                append: true
                            });
                        }
                    }
                    e.preventDefault();
                });
                if (_params.item_preload && _params.popup_prev_selector) {
                    _preload.setPreloadListener({
                        selector: _params.popup_prev_selector,
                        func: _methods.getItem,
                        timeout: 300
                    });
                }
            }
            app.callback('popupClosed', function (popup) {
                var saveIndex = parseInt(scope.history_index || 0, 10);
                scope.history_index = 0;
                if (saveIndex)
                    window.history.go(-saveIndex);
            });
            window.addEventListener('popstate', function (e) {
                if (e.state && e.state.url && scope.history_index) {
                    if (e.state.historyIndex < scope.history_index) {
                        scope.history_index--;
                    }
                    else {
                        scope.history_index++;
                    }
                    _methods.getItem({
                        url: e.state.url,
                        history_increment: false
                    });
                }
                else {
                    if (_params.popup.is('.opened')) {
                        scope.history_index = 0;
                        app.togglePopup(_params.popup.attr('id'));
                    }
                    app.historyRestoreUrl();
                }
            }, false);
        }
        var _return = __assign({}, _methods);
        if (_params.popup) {
            if (_params.item_preload) {
                _return = __assign({}, _return, {
                    preload: _preload
                });
            }
            return _return;
        }
    }
};
Number.isInteger =
    Number.isInteger ||
        function (value) {
            return typeof value === 'number' && isFinite(value) && !(value % 1);
        };
